"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAVIGATION_ITEMS = void 0;
const roles_1 = require("./roles");
const routes_1 = require("./routes");
exports.NAVIGATION_ITEMS = [
    { key: 'cms-home', label: 'CMS', path: routes_1.ROUTES.CMS, area: roles_1.AREAS.CMS },
    {
        key: 'promo-codes-home',
        label: 'Promo Codes',
        path: routes_1.ROUTES.PROMO_CODES,
        area: roles_1.AREAS.PROMO_CODES,
    },
    { key: 'rules', label: 'Rules', path: routes_1.ROUTES.RULES, area: roles_1.AREAS.RULES },
    { key: 'vendors-home', label: 'Vendors', path: routes_1.ROUTES.VENDORS, area: roles_1.AREAS.VENDORS },
];
